import * as yup from 'yup';

export const createValidationSchema = (): yup.AnyObjectSchema => {
  return yup.object({
    companyNameInReports: yup.string().required('common.not_empty'),
  });
};
